// utils/date.ts
export default function formatDatePT(value) {
    if (!value) return "";

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
        return ""; // ou "Data inválida"
    }

    return new Intl.DateTimeFormat("pt-PT").format(date);
}